module.exports = __webpack_public_path__ + "img/42.8.TSS.69816099.png";